<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page  -->
            <h1 class="page__title text-center">{{ $t(titlePage) }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow>
                    <CCol sm="12">
                        <!--Leads-->
                        <CContainer class="container-leads">
                            <CRow>
                                <CCol md="12">
                                    <h3>{{ $t("status_activity") }}</h3>
                                </CCol>
                            </CRow>
                            <CRow class="pt-4 justify-content-center">
                                <CCol md="3" sm="6" class="mb-3">
                                    <div class="position-relative">
                                        <CElementCover
                                            :boundaries="[
                                                { sides: ['top', 'left'] },
                                            ]"
                                            :opacity="0.8"
                                            class="loader-chart-widget"
                                            v-if="charts.captured.loading"
                                        >
                                            <CSpinner grow size="5xl" />
                                        </CElementCover>
                                        <CWidgetDropdown
                                            :header="`${captured.total}`"
                                            :text="$t('new_leads')"
                                            class="color-primary-1"
                                        >
                                            <template #default>
                                                <span
                                                    class="positive-difference"
                                                    :style="
                                                        getColorDiffPercentaje(
                                                            captured.differential_percentaje
                                                        )
                                                    "
                                                >
                                                    ({{
                                                        captured.differential_percentaje
                                                    }}% VS
                                                    {{ $t("yesterday") }})
                                                </span>
                                            </template>
                                            <template #footer>
                                                <CChartLine
                                                    v-bind="charts.captured"
                                                />
                                            </template>
                                        </CWidgetDropdown>
                                    </div>
                                </CCol>
                                <!-- Fin 1º Tabla -->
                                <CCol md="3" sm="6" class="mb-3">
                                    <div class="position-relative">
                                        <CElementCover
                                            :boundaries="[
                                                { sides: ['top', 'left'] },
                                            ]"
                                            :opacity="0.8"
                                            class="loader-chart-widget"
                                            v-if="charts.duplicated.loading"
                                        >
                                            <CSpinner grow size="5xl" />
                                        </CElementCover>
                                        <CWidgetDropdown
                                            :header="`${duplicated.total}`"
                                            :text="$t('duplicated')"
                                            class="color-primary-2"
                                        >
                                            <template #default>
                                                <span
                                                    class="positive-difference"
                                                    :style="
                                                        getColorDiffPercentaje(
                                                            duplicated.differential_percentaje
                                                        )
                                                    "
                                                >
                                                    ({{
                                                        duplicated.differential_percentaje
                                                    }}% VS
                                                    {{ $t("yesterday") }})
                                                </span>
                                            </template>
                                            <template #footer>
                                                <CChartBar
                                                    v-bind="charts.duplicated"
                                                />
                                            </template>
                                        </CWidgetDropdown>
                                    </div>
                                </CCol>
                                <!-- Fin 2º Tabla -->
                                <CCol md="3" sm="6" class="mb-3">
                                    <!-- Leads ok -->
                                    <div class="position-relative">
                                        <CElementCover
                                            :boundaries="[
                                                { sides: ['top', 'left'] },
                                            ]"
                                            :opacity="0.8"
                                            class="loader-chart-widget"
                                            v-if="charts.counted.loading"
                                        >
                                            <CSpinner grow size="5xl" />
                                        </CElementCover>
                                        <CWidgetDropdown
                                            :header="`${counted.total}`"
                                            :text="$t('ok')"
                                            class="color-primary-3"
                                        >
                                            <template #default>
                                                <span
                                                    class="positive-difference"
                                                    :style="
                                                        getColorDiffPercentaje(
                                                            counted.differential_percentaje
                                                        )
                                                    "
                                                >
                                                    ({{
                                                        counted.differential_percentaje
                                                    }}% VS
                                                    {{ $t("yesterday") }})
                                                </span>
                                            </template>
                                            <template #footer>
                                                <CChartLine
                                                    v-bind="charts.counted"
                                                />
                                            </template>
                                        </CWidgetDropdown>
                                    </div>
                                </CCol>
                                <!-- Fin 3º Tabla -->
                                <CCol md="3" sm="6" class="mb-3">
                                    <div class="position-relative">
                                        <CElementCover
                                            :boundaries="[
                                                { sides: ['top', 'left'] },
                                            ]"
                                            :opacity="0.8"
                                            class="loader-chart-widget"
                                            v-if="charts.leads_activity.loading"
                                        >
                                            <CSpinner grow size="5xl" />
                                        </CElementCover>
                                        <CWidgetDropdown
                                            :header="`${lead_activity}`"
                                            :text="$t('activity') + ' (1m)'"
                                            class="color-primary-4"
                                        >
                                            <template #default>
                                                <span
                                                    class="positive-difference"
                                                    :style="
                                                        getColorDiffPercentaje(
                                                            imported.differential_percentaje
                                                        )
                                                    "
                                                >
                                                    ({{
                                                        imported.differential_percentaje
                                                    }}% VS
                                                    {{ $t("yesterday") }})
                                                </span>
                                            </template>
                                            <template #footer>
                                                <CChartBar
                                                    v-bind="
                                                        charts.leads_activity
                                                    "
                                                />
                                            </template>
                                        </CWidgetDropdown>
                                    </div>
                                </CCol>
                            </CRow>
                            <!-- Fin 4º Tabla -->
                            <!-- Sincro Activity -->
                            <CRow>
                                <CCol md="12">
                                    <h3>{{ $t("sincro_activity") }}</h3>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol md="3" sm="6" class="mb-3">
                                    <div class="position-relative">
                                        <CElementCover
                                            :boundaries="[
                                                { sides: ['top', 'left'] },
                                            ]"
                                            :opacity="0.8"
                                            class="loader-chart-widget"
                                            v-if="charts.imported.loading"
                                        >
                                            <CSpinner grow size="5xl" />
                                        </CElementCover>
                                        <CWidgetDropdown
                                            class="color-secondary-1"
                                            :header="`${imported.total}`"
                                            :text="$t('import_leads')"
                                        >
                                            <template #default>
                                                <span
                                                    class="positive-difference"
                                                    :style="
                                                        getColorDiffPercentaje(
                                                            imported.differential_percentaje
                                                        )
                                                    "
                                                >
                                                    ({{
                                                        imported.differential_percentaje
                                                    }}% VS
                                                    {{ $t("yesterday") }})
                                                </span>
                                            </template>

                                            <template #footer>
                                                <CChartLine
                                                    v-bind="charts.imported"
                                                />
                                            </template>
                                        </CWidgetDropdown>
                                    </div>
                                </CCol>
                                <CCol md="3" sm="6" class="mb-3">
                                    <div class="position-relative">
                                        <CElementCover
                                            :boundaries="[
                                                { sides: ['top', 'left'] },
                                            ]"
                                            :opacity="0.8"
                                            class="loader-chart-widget"
                                            v-if="charts.delivered.loading"
                                        >
                                            <CSpinner grow size="5xl" />
                                        </CElementCover>
                                        <CWidgetDropdown
                                            :header="`${delivered.total}`"
                                            :text="$t('delivered_leads')"
                                            class="color-secondary-2"
                                        >
                                            <template #default>
                                                <span
                                                    class="positive-difference"
                                                    :style="
                                                        getColorDiffPercentaje(
                                                            delivered.differential_percentaje
                                                        )
                                                    "
                                                >
                                                    ({{
                                                        delivered.differential_percentaje
                                                    }}% VS
                                                    {{ $t("yesterday") }})
                                                </span>
                                            </template>
                                            <template #footer>
                                                <CChartBar
                                                    v-bind="charts.delivered"
                                                />
                                            </template>
                                        </CWidgetDropdown>
                                    </div>
                                </CCol>
                                <CCol md="3" sm="6" class="mb-3">
                                    <div class="position-relative">
                                        <CElementCover
                                            :boundaries="[
                                                { sides: ['top', 'left'] },
                                            ]"
                                            :opacity="0.8"
                                            class="loader-chart-widget"
                                            v-if="charts.forms.loading"
                                        >
                                            <CSpinner grow size="5xl" />
                                        </CElementCover>
                                        <CWidgetDropdown
                                            :header="`${forms.total}`"
                                            :text="$t('form')"
                                            class="color-secondary-3"
                                        >
                                            <template #default>
                                                <span
                                                    class="positive-difference"
                                                    :style="
                                                        getColorDiffPercentaje(
                                                            forms.differential_percentaje
                                                        )
                                                    "
                                                >
                                                    ({{
                                                        forms.differential_percentaje
                                                    }}% VS
                                                    {{ $t("yesterday") }})
                                                </span>
                                            </template>
                                            <template #footer>
                                                <CChartLine
                                                    v-bind="charts.forms"
                                                />
                                            </template>
                                        </CWidgetDropdown>
                                    </div>
                                </CCol>
                                <CCol md="3" sm="6" class="mb-3">
                                    <div class="position-relative">
                                        <CElementCover
                                            :boundaries="[
                                                { sides: ['top', 'left'] },
                                            ]"
                                            :opacity="0.8"
                                            class="loader-chart-widget"
                                            v-if="charts.integrated.loading"
                                        >
                                            <CSpinner grow size="5xl" />
                                        </CElementCover>
                                        <CWidgetDropdown
                                            :header="`${integrated.total}`"
                                            :text="$t('integration_leads')"
                                            class="color-secondary-4"
                                        >
                                            <template #default>
                                                <span
                                                    class="positive-difference"
                                                    :style="
                                                        getColorDiffPercentaje(
                                                            integrated.differential_percentaje
                                                        )
                                                    "
                                                >
                                                    ({{
                                                        integrated.differential_percentaje
                                                    }}% VS
                                                    {{ $t("yesterday") }})
                                                </span>
                                            </template>
                                            <template #footer>
                                                <CChartBar
                                                    v-bind="charts.integrated"
                                                />
                                            </template>
                                        </CWidgetDropdown>
                                    </div>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol md="6">
                                    <h3>{{ $t("cost_activity") }}</h3>
                                </CCol>
                                <CCol md="3">
                                    <h3>{{ $t("genre_activity") }}</h3>
                                </CCol>
                                <CCol md="3">
                                    <h3>{{ $t("ISP_activity") }}</h3>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol md="3" sm="6" class="mb-3">
                                    <div class="position-relative">
                                        <CElementCover
                                            :boundaries="[
                                                { sides: ['top', 'left'] },
                                            ]"
                                            :opacity="0.8"
                                            class="loader-chart-widget"
                                            v-if="charts.imported.loading"
                                        >
                                            <CSpinner grow size="5xl" />
                                        </CElementCover>
                                        <CWidgetDropdown
                                            class="color-secondary-1"
                                            :header="`${cost.total}`"
                                            :text="$t('cost_leads')"
                                        >
                                            <template #default>
                                                <span
                                                    class="positive-difference"
                                                    :style="
                                                        getColorDiffPercentaje(
                                                            cost.differential_percentaje
                                                        )
                                                    "
                                                >
                                                    ({{
                                                        cost.differential_percentaje
                                                    }}% VS
                                                    {{ $t("yesterday") }})
                                                </span>
                                            </template>

                                            <template #footer>
                                                <CChartLine
                                                    v-bind="charts.cost"
                                                />
                                            </template>
                                        </CWidgetDropdown>
                                    </div>
                                </CCol>
                                <CCol md="3" sm="6" class="mb-3">
                                    <div class="position-relative">
                                        <CElementCover
                                            :boundaries="[
                                                { sides: ['top', 'left'] },
                                            ]"
                                            :opacity="0.8"
                                            class="loader-chart-widget"
                                            v-if="charts.sale.loading"
                                        >
                                            <CSpinner grow size="5xl" />
                                        </CElementCover>
                                        <CWidgetDropdown
                                            :header="`${sale.total}`"
                                            :text="$t('pay_leads')"
                                            class="color-secondary-2"
                                        >
                                            <template #default>
                                                <span
                                                    class="positive-difference"
                                                    :style="
                                                        getColorDiffPercentaje(
                                                            sale.differential_percentaje
                                                        )
                                                    "
                                                >
                                                    ({{
                                                        sale.differential_percentaje
                                                    }}% VS
                                                    {{ $t("yesterday") }})
                                                </span>
                                            </template>
                                            <template #footer>
                                                <CChartBar
                                                    v-bind="charts.sale"
                                                />
                                            </template>
                                        </CWidgetDropdown>
                                    </div>
                                </CCol>
                                <CCol md="3" sm="6" class="mb-3">
                                    <div class="position-relative">
                                        <CElementCover
                                            :boundaries="[
                                                { sides: ['top', 'left'] },
                                            ]"
                                            :opacity="0.8"
                                            class="loader-chart-widget"
                                            v-if="charts.imported.loading"
                                        >
                                            <CSpinner grow size="5xl" />
                                        </CElementCover>
                                        <CWidgetDropdown
                                            class="color-secondary-3"
                                            style="height: 230px"
                                        >
                                            <template #default>
                                                <span
                                                    style="right: 55px"
                                                    class="
                                                        position-relative
                                                        font-weight-bold
                                                    "
                                                >
                                                    {{
                                                        charts.genre
                                                            .datasets[0][
                                                            "data"
                                                        ][0]
                                                    }}
                                                    Male
                                                </span>
                                                <span
                                                    class="
                                                        position-relative
                                                        font-weight-bold
                                                    "
                                                >
                                                    {{
                                                        charts.genre
                                                            .datasets[0][
                                                            "data"
                                                        ][1]
                                                    }}
                                                    Female
                                                </span>
                                            </template>
                                            <template #footer>
                                                <CChartDoughnut
                                                    :labels="
                                                        charts.genre.labels
                                                    "
                                                    :datasets="
                                                        charts.genre.datasets
                                                    "
                                                    :options="
                                                        charts.genre.options
                                                    "
                                                />
                                            </template>
                                        </CWidgetDropdown>
                                    </div>
                                </CCol>
                                <CCol md="3" sm="6" class="mb-3">
                                    <div class="position-relative">
                                        <CElementCover
                                            :boundaries="[
                                                { sides: ['top', 'left'] },
                                            ]"
                                            :opacity="0.8"
                                            class="loader-chart-widget"
                                            v-if="charts.imported.loading"
                                        >
                                            <CSpinner grow size="5xl" />
                                        </CElementCover>
                                        <CWidgetDropdown
                                            style="height: 230px"
                                            class="color-secondary-4"
                                        >
                                            <template #footer>
                                                <CChartPie
                                                    :labels="
                                                        charts.emails.labels
                                                    "
                                                    :datasets="
                                                        charts.emails.datasets
                                                    "
                                                    :options="
                                                        charts.emails.options
                                                    "
                                                />
                                            </template>
                                        </CWidgetDropdown>
                                    </div>
                                </CCol>
                            </CRow>
                            <CRow
                                ><CCol md="12" sm="12">
                                    <h3>{{ $t("leads_activity") }}</h3>
                                </CCol></CRow
                            >
                            <CRow class="pt-4">
                                <CCol md="6" sm="12" class="mb-4">
                                    <CCard class="section mx-3">
                                        <CCardHeader>
                                            <h2 class="section__title">
                                                {{ $t("lead_list") }}
                                            </h2>
                                        </CCardHeader>
                                        <CCardBody>
                                            <CDataTable
                                                :addTableClasses="['table--sm']"
                                                :items="tables.lead_list.items"
                                                :fields="
                                                    traslateArrayObjects({
                                                        array: tables.lead_list
                                                            .fields,
                                                        fields: ['label'],
                                                    })
                                                "
                                                :items-per-page="
                                                    tables.lead_list.rows
                                                "
                                                :loading="
                                                    tables.lead_list.loading
                                                "
                                                :noItemsView="{
                                                    noItems: $t('no_leads'),
                                                }"
                                                hover
                                                pagination
                                                striped
                                            >
                                                <template #id="{ index }">
                                                    <td>
                                                        {{ index + 1 }}
                                                    </td>
                                                </template>
                                            </CDataTable>
                                        </CCardBody>
                                        <CCardFooter
                                            v-if="
                                                tables.lead_list.total_pages > 0
                                            "
                                        >
                                            <CPagination
                                                @update:activePage="
                                                    updatePagination
                                                "
                                                :activePage="
                                                    tables.lead_list.page
                                                "
                                                :pages="
                                                    tables.lead_list.total_pages
                                                "
                                                size="sm"
                                                align="center"
                                            />
                                        </CCardFooter>
                                    </CCard>
                                </CCol>
                                <CCol md="6" sm="12" class="mb-4">
                                    <CCard class="section mx-3">
                                        <CCardHeader>
                                            <h2 class="section__title">
                                                {{ $t("origin_list") }}
                                            </h2>
                                        </CCardHeader>
                                        <CCardBody>
                                            <CDataTable
                                                :addTableClasses="['table--sm']"
                                                :items="
                                                    tables.origin_list.items
                                                "
                                                :fields="
                                                    traslateArrayObjects({
                                                        array: tables
                                                            .origin_list.fields,
                                                        fields: ['label'],
                                                    })
                                                "
                                                :items-per-page="
                                                    tables.origin_list.rows
                                                "
                                                :loading="
                                                    tables.origin_list.loading
                                                "
                                                :noItemsView="{
                                                    noItems: $t('no_leads'),
                                                }"
                                                hover
                                                pagination
                                                striped
                                            >
                                                <template #origin="{ item }">
                                                    <td>
                                                        <span
                                                            v-if="item.origin"
                                                        >
                                                            {{ item.origin }}
                                                        </span>
                                                    </td>
                                                </template>
                                                <template #id="{ index }">
                                                    <td>
                                                        {{ index + 1 }}
                                                    </td>
                                                </template>
                                            </CDataTable>
                                        </CCardBody>
                                    </CCard>
                                </CCol>

                                <CCol md="6" sm="12" class="mb-4">
                                    <CCard class="section mx-3">
                                        <CCardHeader>
                                            <h2 class="section__title">
                                                {{ $t("form_list") }}
                                            </h2>
                                        </CCardHeader>
                                        <CCardBody>
                                            <CDataTable
                                                :addTableClasses="['table--sm']"
                                                :items="tables.form_list.items"
                                                :fields="
                                                    traslateArrayObjects({
                                                        array: tables.form_list
                                                            .fields,
                                                        fields: ['label'],
                                                    })
                                                "
                                                :items-per-page="
                                                    tables.lead_list.rows
                                                "
                                                :loading="
                                                    tables.lead_list.loading
                                                "
                                                :noItemsView="{
                                                    noItems: $t('no_leads'),
                                                }"
                                                hover
                                                pagination
                                                striped
                                            >
                                                <template #id="{ index }">
                                                    <td>
                                                        {{ index + 1 }}
                                                    </td>
                                                </template>
                                            </CDataTable>
                                        </CCardBody>
                                    </CCard>
                                </CCol>
                                <CCol md="6" sm="12" class="mb-4">
                                    <CCard class="section mx-3">
                                        <CCardHeader>
                                            <h2 class="section__title">
                                                {{ $t("integration_list") }}
                                            </h2>
                                        </CCardHeader>
                                        <CCardBody>
                                            <CDataTable
                                                :addTableClasses="['table--sm']"
                                                :items="
                                                    tables.integration_list
                                                        .items
                                                "
                                                :fields="
                                                    traslateArrayObjects({
                                                        array: tables
                                                            .integration_list
                                                            .fields,
                                                        fields: ['label'],
                                                    })
                                                "
                                                :items-per-page="
                                                    tables.integration_list.rows
                                                "
                                                :loading="
                                                    tables.integration_list
                                                        .loading
                                                "
                                                :noItemsView="{
                                                    noItems: $t('no_leads'),
                                                }"
                                                hover
                                                pagination
                                                striped
                                            >
                                                <template #id="{ index }">
                                                    <td>
                                                        {{ index + 1 }}
                                                    </td>
                                                </template>
                                            </CDataTable>
                                        </CCardBody>
                                    </CCard>
                                </CCol>
                            </CRow>
                        </CContainer>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
import { cilCalendar, cilArrowTop } from "@coreui/icons";
import { mapGetters } from "vuex";
import pageMixin from "~/mixins/page.js";
import chartMixin from "~/mixins/chart.js";
import {
    CChartBar,
    CChartLine,
    CChartPie,
    CChartRadar,
    CChartDoughnut,
} from "@coreui/vue-chartjs";
import FormsChart from "./charts/forms";
import CapturesChart from "./charts/captures";
import OriginsChart from "./charts/origins";
import ImportsChart from "./charts/imports";
import IntegrationsChart from "./charts/integrations";
import DeliveriesChart from "./charts/deliveries";
import DuplicatesChart from "./charts/duplicates";
import ActivityChart from "./charts/activity";
import CountesChart from "./charts/countes";
import CostChart from "./charts/cost";
import SaleChart from "./charts/sale";
import GenreChart from "./charts/genre";
import EmailsChart from "./charts/emails";
import Footer from "../../../components/elements/footer.vue";
import LeadListTable from "~/pages/app/dashboard/tables/lead_list";
import OriginListTable from "~/pages/app/dashboard/tables/origin_list";
import FormListTable from "~/pages/app/dashboard/tables/form_list";
import IntegrationListTable from "~/pages/app/dashboard/tables/integration_list";
export default {
    name: "DashboardPage",
    middleware: ["auth", "page"],
    mixins: [chartMixin, pageMixin],
    components: {
        CChartBar,
        CChartLine,
        CChartPie,
        CChartRadar,
        CChartDoughnut,
        Footer,
    },
    icons: {
        cilCalendar,
        cilArrowTop,
    },
    data: function () {
        return {
            interval: null,
            captured: {
                total: 0,
                differential_percentaje: 0,
            },
            duplicated: {
                total: 0,
                differential_percentaje: 0,
            },
            counted: {
                total: 0,
                differential_percentaje: 0,
            },
            imported: {
                total: 0,
                differential_percentaje: 0,
            },
            integrated: {
                total: 0,
                differential_percentaje: 0,
            },
            delivered: {
                total: 0,
                differential_percentaje: 0,
            },
            forms: {
                total: 0,
                differential_percentaje: 0,
            },
            cost: {
                total: 0,
                differential_percentaje: 0,
            },
            sale: {
                total: 0,
                differential_percentaje: 0,
            },
            genre: {
                total: 0,
            },
            emails: {
                total: 0,
            },
            lead_activity: 0,
            tables: {
                lead_list: LeadListTable,
                origin_list: OriginListTable,
                form_list: FormListTable,
                integration_list: IntegrationListTable,
            },
            charts: {
                captured: CapturesChart,
                duplicated: DuplicatesChart,
                counted: CountesChart,
                leads_activity: ActivityChart,
                forms: FormsChart,
                leads_origins: OriginsChart,
                imported: ImportsChart,
                integrated: IntegrationsChart,
                delivered: DeliveriesChart,
                cost: CostChart,
                sale: SaleChart,
                genre: GenreChart,
                emails: EmailsChart,
            },
            urls: {
                heartbeat_leads: "/dashboard/heartbeatlead",
            },
        };
    },
    computed: {
        ...mapGetters({
            from: "filter/from",
            to: "filter/to",
        }),
        isIdle() {
            return this.$store.state.idleVue.isIdle;
        },
    },
    methods: {
        updatePagination(newValue) {
            this.tables.lead_list.page = newValue;
            this.updateData({
                from: this.from,
                to: this.to,
            });
        },
        // async heartbeatLeads() {
        //     let data = await this.loadData({
        //         url: this.urls.heartbeat_leads,
        //     });
        //     this.lead_activity = data.count;
        // },
        // async listenByInterval(intervalTime = 60000) {
        //     if (this.checkPagePromiseContinue()) return;
        //     this.interval = setInterval(() => {
        //         this.heartbeatLeads();
        //     }, intervalTime);
        //     this.heartbeatLeads();
        // },
        async loadRealTimeStatusActivity() {
            if (this.checkPagePromiseContinue()) return;
            let data = await this.fetcher({
                url: "/dashboard.api/realtime/status/activity",
            });

            for (let key in data.items) {
                this[key] = data.items[key];
                this[key].total = data.items[key].today.total;
                this[key].differential_percentaje =
                    data.items[key].differential_percentaje;

                this.loadChart({
                    chartName: key,
                    chartData: [
                        {
                            label: "Today",
                            data: data.items[key].today.breakdown.values,
                            config: this.charts[key].config.datasets.today,
                        },
                        {
                            label: "Yesterday",
                            data: data.items[key].yesterday.breakdown.values,
                            config: this.charts[key].config.datasets.yesterday,
                        },
                    ],
                    labels: data.items[key].today.breakdown.headers,
                });
            }
        },

        async loadRealTimeSincroActivity() {
            if (this.checkPagePromiseContinue()) return;
            let data = await this.fetcher({
                url: "/dashboard.api/realtime/sincro/activity",
            });

            for (let key in data.items) {
                this[key] = data.items[key];
                this[key].total = data.items[key].today.total;
                this[key].differential_percentaje =
                    data.items[key].differential_percentaje;

                this.loadChart({
                    chartName: key,
                    chartData: [
                        {
                            label: "Today",
                            data: data.items[key].today.breakdown.values,
                            config: this.charts[key].config.datasets.today,
                        },
                        {
                            label: "Yesterday",
                            data: data.items[key].yesterday.breakdown.values,
                            config: this.charts[key].config.datasets.yesterday,
                        },
                    ],
                    labels: data.items[key].today.breakdown.headers,
                });
            }
        },

        async loadRealTimeCostActivity() {
            if (this.checkPagePromiseContinue()) return;
            let data = await this.fetcher({
                url: "/dashboard.api/realtime/cost/activity",
            });

            for (let key in data.items) {
                this[key] = data.items[key];
                this[key].total = data.items[key].today.total;
                this[key].differential_percentaje =
                    data.items[key].differential_percentaje;

                this.loadChart({
                    chartName: key,
                    chartData: [
                        {
                            label: "Today",
                            data: data.items[key].today.breakdown.values,
                            config: this.charts[key].config.datasets.today,
                        },
                        {
                            label: "Yesterday",
                            data: data.items[key].yesterday.breakdown.values,
                            config: this.charts[key].config.datasets.yesterday,
                        },
                    ],
                    labels: data.items[key].today.breakdown.headers,
                });
            }
        },

        async loadRealTimeSaleActivity() {
            if (this.checkPagePromiseContinue()) return;
            if (this.$options.name != "DashboardPage") return;
            let data = await this.fetcher({
                url: "/dashboard.api/realtime/sale/activity",
            });

            for (let key in data.items) {
                this[key] = data.items[key];
                this[key].total = data.items[key].today.total;
                this[key].differential_percentaje =
                    data.items[key].differential_percentaje;

                this.loadChart({
                    chartName: key,
                    chartData: [
                        {
                            label: "Today",
                            data: data.items[key].today.breakdown.values,
                            config: this.charts[key].config.datasets.today,
                        },
                        {
                            label: "Yesterday",
                            data: data.items[key].yesterday.breakdown.values,
                            config: this.charts[key].config.datasets.yesterday,
                        },
                    ],
                    labels: data.items[key].today.breakdown.headers,
                });
            }
        },

        async loadGeneralInfoActivity() {
            if (this.checkPagePromiseContinue()) return;
            let info = await this.fetcher({
                url: "/dashboard.api/realtime/general/info",
            });

            this.charts.genre.labels = info.items.genre.map((item) => {
                return item.genre.toUpperCase();
            });
            
            this.charts.genre.datasets[0]["data"] = info.items.genre.map((item) => {
                return item.total;
            });

            this.charts.emails.labels = info.items.emails.map((item) => {
                return item.email_domain;
            });

            this.charts.emails.datasets[0]["data"] = info.items.emails.map(
                (item) => {
                    return item.total;
                }
            );


            // this.charts.genre.datasets.push(
            //     this.createChartDataSet(
            //         this.charts.genre.data,
            //         this.charts.genre.label,
            //         this.charts.genre.config,
            //         this.charts.genre.options
            //     )
            // );
            // this.charts.emails.datasets.push(
            //     this.createChartDataSet(
            //         this.charts.emails.data,
            //         this.charts.emails.label,
            //         this.charts.emails.config,
            //         this.charts.emails.options
            //     )
            // );
        },

        async loadRealTimeLeadActivity() {
            if (this.checkPagePromiseContinue()) return;
            let data = await this.fetcher({
                url: "/dashboard.api/realtime/leads/activiy",
            });

            this.tables.lead_list.items = this.normalizeArrayData({
                data: data.items.last_leads_captured,
            });
            this.tables.lead_list.loading = false;

            this.tables.origin_list.items = this.normalizeArrayData({
                data: data.items.last_leads_captured_by_origin,
            });
            this.tables.origin_list.loading = false;

            this.tables.integration_list.items = this.normalizeArrayData({
                data: data.items.last_leads_integrated,
            });
            this.tables.integration_list.loading = false;

            this.tables.form_list.items = this.normalizeArrayData({
                data: data.items.last_leads_captured_by_forms,
            });
            this.tables.form_list.loading = false;
        },
        async loadLeadsRealTime() {
            await this.loadRealTimeStatusActivity();
            await this.loadRealTimeSincroActivity();
            await this.loadRealTimeLeadActivity();
            await this.loadRealTimeCostActivity();
            await this.loadRealTimeSaleActivity();
            await this.loadGeneralInfoActivity();
        },
        async updateData() {
            this.tables.lead_list.loading = true;
            this.$store.dispatch("page/updateLoading", {
                loading: false,
            });
            await this.loadLeadsRealTime();
        },

        createChartDataSet(data, label, config) {
            let dataset = {
                label, // Se especifica el nombre de la base de datos del dato representado.
                data, // Se especifica el valor del dato representado.
                fill: false,
                tension: 0.1,
            };
            if (config && config.borderColor) {
                if (config.borderColor == "random") {
                    config.borderColor = this.generateRamdomColor();
                }
                dataset.borderColor = config.borderColor;
            }

            if (config && config.backgroundColor) {
                if (config.backgroundColor == "random") {
                    config.backgroundColor = this.generateRamdomColor();
                }
                dataset.backgroundColor = config.backgroundColor;
            }
            return dataset;
        },

        createChartDataSetsFromArray(data) {
            let datasets = [];
            data.forEach((element) => {
                datasets.push(
                    this.createChartDataSet(
                        element.data,
                        element.label,
                        element.config
                    )
                );
            });
            return datasets;
        },

        generateRamdomColor() {
            const letters = "0123456789ABCDEF";
            let color = "#";
            for (let i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
        },
        loadChart({ chartName, chartData = [], labels }) {
            let chart = this.charts[chartName];
            chart.datasets = [];
            chart.datasets = this.createChartDataSetsFromArray(chartData);
            chart.labels = labels;
            chart.loading = false;
        },

        getColorDiffPercentaje(percentaje) {
            if (parseInt(percentaje) >= 0) {
                return {
                    color: "white",
                };
            } else {
                return {
                    color: "red",
                };
            }
        },
    },
    async mounted() {
        await this.updateData();
        // await this.listenByInterval();
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
};
</script>
<style scoped lang="scss">
.block-icon {
    display: flex;
    justify-content: center;
    & .icon {
        height: 2em;
        width: auto;
    }
}

.container-leads {
    @media (min-width: 1200px) {
        max-width: 1550px;
    }
}
.loader-chart-widget {
    z-index: 3;
    background-color: transparent !important;
}
</style>
